import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'

const useCreateVirtualMachineModalStyles = makeStyles<Theme>((theme) => ({
  fields: {
    display: 'grid',
    gap: 16,
    marginBottom: 32,
    height: 'fit-content',
  },
  info: {
    background: theme.palette.grey[50],
  },
  infoContent: {
    display: 'grid',
    gap: 8,
  },
  halfColumns: {
    display: 'grid',
    gap: 24,
    gridTemplateColumns: '1fr 1fr',
    alignItems: 'baseline',
  },
  spaceBelow: {
    marginBottom: 16,
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gap: 16,
  },
  card: {
    height: 'calc(100% - 32px)',
    alignItems: 'center',
    padding: '16px 24px',
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    paddingBottom: 8,
    marginBottom: 8,
    display: 'grid',
    gridTemplateColumns: 'auto max-content',
    alignItems: 'center',
  },
  gpuTag: {
    background: theme.palette.blue[100],
    border: `1px solid ${theme.palette.blue[700]}`,
    borderRadius: 4,
    padding: '2px 8px',
    color: theme.palette.blue[700],
    fontWeight: 600,
  },
  cardText: {
    fontSize: 12,
  },
  pairs: {
    display: 'grid',
    gap: 4,
  },
  separator: {
    height: 1,
    width: '100%',
    background: theme.palette.grey[200],
    margin: '16px 0px',
  },
  networkModeCards: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  networkCardWrapper: {
    position: 'relative',
    width: '100%',
  },
  networkCard: {
    width: '100%',
    height: '100%',
  },
  networkCardBody: {
    display: 'grid',
    gridGap: theme.spacing(1),
    gridTemplateColumns: 'max-content 1fr max-content',
    padding: '16px',
    placeItems: 'center',
  },
  networkCardContent: {
    justifySelf: 'left',
  },
  networkInfoIcon: {
    color: theme.palette.grey[500],
    fontSize: '20px',
    cursor: 'help',
  },
  networkTooltipBody: {
    maxWidth: 250,
  },
  vmCount: {
    display: 'grid',
    gridTemplateColumns: 'auto 130px',
    gap: 16,
    alignItems: 'center',
  },
  vmCountDisabled: {
    cursor: 'not-allowed',
  },
  vmCountInput: {
    display: 'grid',
    gridTemplateColumns: 'auto max-content',
    alignItems: 'center',
    gap: 8,
  },
  vmCountText: {
    fontSize: 12,
  },
  disabledText: {
    color: theme.palette.grey[500],
  },
  tabbed: {
    display: 'grid',
    gap: theme.spacing(2),
    marginLeft: theme.spacing(6.75),
  },
  // Keep the Cloud-init editor at the modal's width so long lines scroll inside the editor
  // instead of widening the whole modal (grid items otherwise grow to fit their content).
  cloudInitEditor: {
    minWidth: 0,
    gridTemplateColumns: 'minmax(0, 1fr)',
    // The editor card's loading wrapper is a grid too; apply the same rule so the editor itself
    // (not the card) is what scrolls sideways.
    '& .progress-root': {
      minWidth: 0,
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
    '& .progressContent, & .react-codemirror2': {
      minWidth: 0,
    },
  },
  passwordScreen: {
    display: 'grid',
    gap: 24,
    height: 'fit-content',
  },
  filters: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gap: 16,
  },
  warning: {
    background: theme.palette.yellow[100],
    display: 'grid',
    gap: theme.spacing(1),
  },
  switchTooltip: {
    padding: theme.spacing(1),
    color: theme.palette.common.white,
  },
  tooltipContainer: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  toggleLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  tooltipLink: {
    color: theme.components.tooltip.text,
    textDecoration: 'underline',
    '& > span': {
      color: theme.components.tooltip.text,
    },
  },
  fullWidth: {
    maxWidth: '100%',
  },
}))

export default useCreateVirtualMachineModalStyles
